import React from 'react';
import VATCalculator from './components/VATCalculator';
import './styles/styles';

const App = () => (
    <div className="app-container">
        <VATCalculator />
    </div>
);

export default App;